import styled from "styled-components";
import { PRIMARY, SECONDARY } from "../../const/colors";

export const ContainerModal = styled.div`
position: relative;
  background-color: #fff;
	border: 1px solid ${PRIMARY};
  width: 70vw;
  min-height: 60vh;

  iframe {
    width: 100%;
    height: 600px;
  }
  @media screen and (max-width: 762px) {
    width: 80vw;

    iframe {
      width: 100%;
      height: 500px;
    }
  }
`;

export const Button = styled.div`
  position: absolute;
  top: 0rem;
  right: 0rem;
  background-color: #93291E;
  color: #fff;
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
	svg {
		font-size: 1.5rem;
	}
	&:hover {
		opacity: 0.8;
	}
`;
